import { Component, OnInit } from '@angular/core';
import { ColDef, GridApi, GridOptions, GridReadyEvent, SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy } from 'ag-grid-community';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgxSpinnerService } from 'ngx-spinner';
import { NumberFormatterPipe } from 'src/app/shared/number-formatter.pipe';
import { FacultyService } from '../faculty.service';
import { FacultytrackingnewdialogComponent } from '../facultytrackingnewdialog/facultytrackingnewdialog.component';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { NewperiodImageDialogComponent } from '../newperiod-image-dialog/newperiod-image-dialog.component';
import { TimetableCellData, TimetableCellRenderer } from '../faculty-tracking-new-dashboard/timetable-cell-renderer/timetable-cell-renderer.component'
import { DialogFilterComponent } from '../dialog-filter/dialog-filter.component';

@Component({
  selector: 'app-faculty-tracking-new-dashboard',
  templateUrl: './faculty-tracking-new-dashboard.component.html',
  styleUrls: ['./faculty-tracking-new-dashboard.component.scss']
})
export class FacultyTrackingNewDashboardComponent implements OnInit {
  selectedDate = new Date();
  customDate: any;
  private numberFormatterPipe: NumberFormatterPipe = new NumberFormatterPipe()
  customRange: { start?: Date; end?: Date } = {};
  colDefs: ColDef<any>[] = [
    {
      field: 'los',
      headerName: 'Los',
      pinned: 'left',
      headerStyle: { 'text-align': 'center', },
    },

    {
      field: 'total', headerName: 'Total',
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center', },
      valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
    },

    {
      field: 'started', headerName: 'Started',
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center', },
      valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
    },
    {
      field: 'pending', headerName: 'Pending',
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center', },
      valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
    },
    {
      field: 'percentage', headerName: 'Total Percentage',
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center', },
      valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
    }
  ]


  //row intialization
  rowData: any[] = [];
  pinnedTopRowData: any[] = [];



  // default
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    menuTabs: [],
    suppressHeaderMenuButton: true,

  };
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
      type: "fitCellContents",
    };

  quickFilter: string = '';
  los: any;
  stateName: any;
  stateId: any;
  cityId: any;
  cityName: any;
  campusId: any;
  campusName: any;
  activeTab: any = "Today";
  currentTable: any = ''
  empId: any;
  empName: any;
  key: any = "Today";
  losTableData: any;
  stateTableData: any;
  cityTableData: any;
  campusTableData: any;
  employeeTableData: any;
  periodTableData: any;

  // new feature 16/12/2025 //
  overall: any = false;
  section: any = true;
  overallList: any = false;
  rowHeight = 71;
  showDate: any = true;
  selectionData: any;
  showLocation: any = true;
  showFilter: any = true;

  private gridApi!: GridApi;
  private gridColumnApi: any;
  PendingData: any;


  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }
  facultyOverallData: any[] = [];
  public overlayNoRowsTemplate = '<span class="no-rows">No data found</span>';

  constructor(private httpservice: FacultyService, private dialog: NgDialogAnimationService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.customDate = moment(this.selectedDate).format("DD-MM-YYYY");
    this.getOverallDashboard();

  }
  getStatusColor(status: string): string {
    switch (status.toUpperCase()) {
      case 'TOTAL CAMPUS': return '#1E88E5';
      case 'STARTED': return '#43A047';
      case 'PENDING': return '#FB8C00';
      case 'COMPLETED': return '#E53935';
      default: return '#9E9E9E'; // fallback grey
    }
  }
  getIcon(status: string): string {
    switch (status.toUpperCase()) {
      case 'TOTAL CAMPUS': return 'assets/image/facultyTracking/ph_building-light.svg';
      case 'STARTED': return 'assets/image/facultyTracking/started.svg';
      case 'PENDING': return 'assets/image/facultyTracking/pending.svg';
      case 'COMPLETED': return 'assets/image/facultyTracking/percentage.svg';
      default: return '';
    }
  }

  getBarColor(status: string): string {
    switch (status.toUpperCase()) {
      case 'TOTAL CAMPUS': return '#026FD4';
      case 'STARTED': return '#0CA766';
      case 'PENDING': return '#FB9D05';
      case 'COMPLETED': return '#FF333A';
      default: return '#D9D9D9';
    }
  }

  onDateSelected(event: any) {
    this.selectedDate = event.value;
    this.customDate = moment(this.selectedDate).format("DD-MM-YYYY");
    this.getSectionTableData();
  }


  getOverallDashboard() {
    this.spinner.show()
    this.httpservice.getOverallDashboardData(this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        // console.log('new', res)
        this.facultyOverallData = res;
        this.spinner.hide();
        this.getLosTableData();
      },
      error: (error: any) => {
        // console.log(error)
        this.spinner.hide()
      }
    })
  }

  getLosTableData() {
    this.getLosColumns();
    this.httpservice.getLosTableData(this.customDate).subscribe({
      next: (res: any) => {
        // console.log(res)
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.rowData = res ? res : [];
        this.losTableData = res ? res : [];
        this.spinner.hide();
      },
      error: (error: any) => {
        console.log(error);
        this.spinner.hide();
      }
    })
  }

  getLosColumns() {
    this.colDefs = [
      {
        field: 'los',
        headerName: 'LOL',
        pinned: 'left',

        cellRenderer: (params: any) => {
          return `<a href="javascript:void(0)" style="color: #0564B1; text-decoration: none;font-weight: 400;font-family:'poppins'">${params.value}</a>`;
        },
        headerStyle: { 'text-align': 'center', },
        onCellClicked: (params) => this.getStateTableData(params.data)
      },

      {
        field: 'total', headerName: 'Total Campus',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },

        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },

      {
        field: 'started', headerName: 'Started Teaching',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },

        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },
      {
        field: 'pending', headerName: 'Pending',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },

        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },
      {
        field: 'percentage', headerName: 'Pending Percentage',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },

        // valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
        valueFormatter: (params: any) => {
          const val = this.numberFormatterPipe.transform(params.value);
          return val !== null && val !== undefined ? `${val}%` : '';
        }

      }
    ]
  }

  getStateTableData(params: any) {
    this.showDate = true;
    this.spinner.show();
    this.currentTable = "";
    this.rowData = [];
    this.gridApi?.setGridOption('rowData', []);
    this.getStateColumns();
    this.los = params.los;
    this.httpservice.getStateTableData(this.los, this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        // console.log(res)
        this.rowData = res ? res : []
        this.stateTableData = res ? res : []
        this.spinner.hide()
      },
      error: (error: any) => {
        // console.log(error)
        this.spinner.hide()
      }
    })
  }

  getStateColumns() {
    this.colDefs = [
      {
        field: 'stateName',
        headerName: 'State',
        pinned: 'left',
        cellRenderer: (params: any) => {
          return `<a href="javascript:void(0)" style="color: #0564B1; text-decoration: none;font-weight: 400;font-family:'poppins'">${params.value}</a>`;
        },
        headerStyle: { 'text-align': 'center', },
        onCellClicked: (params) => this.getCityTableData(params.data)
      },

      {
        field: 'stateId', headerName: 'stateId', hide: true,
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },

      {
        field: 'total', headerName: 'Total Employee ',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },

      {
        field: 'started', headerName: 'Started Teaching',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },
      {
        field: 'pending', headerName: 'Pending',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },
      {
        field: 'percentage', headerName: 'Pending Percentage',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      }
    ]
  }

  getCityTableData(params: any) {
    this.quickFilter = '';
    this.spinner.show();
    this.currentTable = "";
     this.rowData = [];
    this.gridApi?.setGridOption('rowData', []);
    this.getCityColumns();
    console.log(params)
    this.stateId = params.stateId;
    this.stateName = params.stateName;

    this.httpservice.getCityTableData(this.los, this.stateId, this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        // console.log(res)
        this.rowData = res ? res : []
        this.cityTableData = res ? res : []
        this.spinner.hide();
      },
      error: (error: any) => {
        // console.log(error);
        this.spinner.hide();
      }
    })
  }

  getCityColumns() {
    this.colDefs = [
      {
        field: 'cityName',
        headerName: 'City',
        pinned: 'left',
        cellRenderer: (params: any) => {
          return `<a href="javascript:void(0)" style="color: #0564B1; text-decoration: none;font-weight: 400;font-family:'poppins'">${params.value}</a>`;
        },
        headerStyle: { 'text-align': 'center', },
        onCellClicked: (params) => this.getCampusTableData(params.data)
      },

      {
        field: 'total', headerName: 'Total Employee',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },

      {
        field: 'started', headerName: 'Started Teaching',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },
      {
        field: 'pending', headerName: 'Pending',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      },
      {
        field: 'percentage', headerName: 'Pending Percentage',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
        valueFormatter: (params: any) => this.numberFormatterPipe.transform(params.value)
      }
    ]
  }

  getCampusTableData(params: any) {
    this.spinner.show();
    this.currentTable = "";
     this.rowData = [];
    this.gridApi?.setGridOption('rowData', []);
    this.getcampusColumns();
    console.log(params)
    this.cityId = params.cityId
    this.cityName = params.cityName

    this.httpservice.getCampusTableData(this.cityId, this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide()
          return;
        }
        // console.log('principle', res)
        this.rowData = res ? res : []
        this.campusTableData = res ? res : []
        this.spinner.hide();
      },
      error: (error: any) => {
        // console.log(error)
        this.spinner.hide()
      }
    })
  }

  getcampusColumns() {
    this.colDefs = [
      {
        field: 'cityName', headerName: 'City',
        cellStyle: { 'text-align': 'center' },
        headerStyle: { 'text-align': 'center', },
      },
      {
        field: 'campusName',
        headerName: 'Campus',
        // pinned: 'left',
        cellRenderer: (params: any) => {
          return `<a href="javascript:void(0)" style="color: #0564B1; text-decoration: none;font-weight: 400;font-family:'poppins'">${params.value}</a>`;
        },
        headerStyle: { 'text-align': 'center', },
        onCellClicked: (params) => this.getSectionTableData(params.data)
      },

      {
        field: 'principalName', headerName: 'Principal Name',
        cellStyle: { 'text-align': 'left' },
        headerStyle: { 'text-align': 'center', },
      },
      {
        field: 'contactNo', headerName: 'Contact No',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },

      },
      {
        field: 'startedSections', headerName: 'Started Sections',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },

      },
      {
        field: 'pendingSections', headerName: 'Pending Sections',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },

      },
      {
        field: 'pendingPercentage', headerName: 'Pending Percentage',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },

      }
    ]
  }


  getSectionTableData(params?: any) {
    this.showFilter = false;
    this.showDate = false;
    this.showLocation = false;
    this.quickFilter = '';
    this.getSectionWiseData();
    this.spinner.show();
    this.overall = true;
    this.overallList = true;
    this.section = false;

    if (params) {
      this.campusId = params.campusId;
      this.campusName = params.campusName;
    }

    this.httpservice.getSectionwise(this.campusId, this.customDate).subscribe({
      next: (res: any) => {
        if (!res || !res.sectionWiseDetails) {
          this.rowData = [];
          this.gridApi.setGridOption('rowData', []);
          this.spinner.hide();
          return;
        }

        this.rowData = res.sectionWiseDetails.map((section: any, i: number) => {
          const row: any = {
            sectionName: section.sectionName,
            sectionStudentCount: section.studentCount,
            section: `${(i + 1).toString().padStart(2, '0')}. ${section.shortName} (${section.studentCount})`
          };
          section.facultyDetails.forEach((fd: any) => {
            const colKey = fd.periodName;   // 👈 IMPORTANT: NO LOWERCASE
            row[colKey] = this.toTimetableCell(fd);
          });
          return row;
        });
        this.gridApi.setGridOption("rowData", this.rowData);
        // console.log("FINAL TABLE ROWS", this.rowData);
        this.selectionData = res;
        this.spinner.hide();
      },
      error: (error: any) => {
        // console.log(error)
        this.spinner.hide();
      }
    })
  }

  getSectionWiseData() {
    this.colDefs = [
      { field: 'section', headerName: 'Section (Strength)', pinned: 'left', width: 150, cellStyle: { 'display': 'flex', 'align-items': 'center', 'font-weight': '500', 'color': '#555' } },

      // PERIODS
      { field: 'P1', headerName: 'P1', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P2', headerName: 'P2', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P3', headerName: 'P3', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P4', headerName: 'P4', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P5', headerName: 'P5', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P6', headerName: 'P6', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P7', headerName: 'P7', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P8', headerName: 'P8', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P9', headerName: 'P9', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P10', headerName: 'P10', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P11', headerName: 'P11', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'P12', headerName: 'P12', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },

      // S PERIODS
      { field: 'S1', headerName: 'S1', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'S2', headerName: 'S2', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'S3', headerName: 'S3', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'S4', headerName: 'S4', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'S5', headerName: 'S5', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'S6', headerName: 'S6', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'S7', headerName: 'S7', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
      { field: 'S8', headerName: 'S8', minWidth: 47, cellRenderer: TimetableCellRenderer, cellStyle: { padding: '0px' }, onCellClicked: (params: any) => { this.clickedData(params); } },
    ];
  }

  gridOptions: GridOptions = {
    rowHeight: 90,
    headerHeight: 50,
  };

  getteachPeriodList() {
    this.spinner.show();
    this.httpservice.getAllPeriodsData().subscribe({
      next: (res: any) => {
        if (!res) {
          this.rowData = [];
          this.spinner.hide();
          return;
        }
        console.log('periodList', res);
        const visible = res.map((e: any) => e.periodName);
        // console.log(visible);
        this.colDefs.forEach(col => {
          if ((col as any).field === 'section') return;

          if ((col as any).field === 'shortName') return;

          const colId = (col as any).colId ?? (col as any).field;

          if ((this.gridApi as any)?.setColumnsVisible) {
            this.gridApi.setColumnsVisible([colId], visible.includes(colId));
          } else {
            this.gridColumnApi?.setColumnVisible(colId, visible.includes(colId));
          }
        });
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  private toTimetableCell(fd: any): TimetableCellData {
    if (!fd.empName) {
      return { type: "NO_CLASS" };
    }

    if (fd.empName.toLowerCase() === "exam") {
      return { type: "EXAM" };
    }

    return {
      type: "CLASS",
      employeeName: fd.empName,
      startTime: fd.classStartTime,
      endTime: fd.classEndTime,
      duration: fd.duration,
      payrollId: fd.payrollId,
      imageList: fd.images,
      subject: fd.subject,
      topicName: fd.topicName,
      subTopicName: fd.subTopicName,
      studentCount: fd.studentCount,
      periodName: fd.periodName,
      sectionStudentCount: fd.sectionStudentCount,
      sectionName: fd.sectionName,
      image: fd.tempId
        ? `${environment.masterDomain}/employee/login/v2/api/profileImage?userId=${fd.tempId}`
        : null
    };
  }

  // classCellRenderer(params: any) {
  //   const data = params.value;
  //   // ---------- NO CLASS ----------
  //   if (!data || data === "No Class") {
  //     return `
  //     <div style="
  //       background:#FDD9D7;
  //       border:1px solid #F5A7A3;
  //       border-radius:10px;
  //       padding:12px;
  //       height:100%;
  //       display:flex;
  //       justify-content:center;
  //       align-items:center;
  //       font-weight:600;
  //       color:#444;
  //       text-align:center;
  //     ">
  //       No Class
  //     </div>
  //   `;
  //   }

  //   // ---------- EXAM ----------
  //   if (data?.teacher === "Exam") {
  //     return `
  //     <div style="
  //       background:#D8E8FF;
  //       border:1px solid #A5C3F7;
  //       border-radius:10px;
  //       padding:12px;
  //       height:100%;
  //       display:flex;
  //       justify-content:center;
  //       align-items:center;
  //       font-weight:600;
  //       color:#1A3A6B;
  //       text-align:center;
  //     ">
  //       Exam
  //     </div>
  //   `;
  //   }

  //   // ---------- NORMAL CLASS ----------
  //   return `
  //   <div style="
  //     background:#E4F8E9;
  //     border:1px solid #A4D8A8;
  //     border-radius:10px;
  //     padding:8px;
  //     height:100%;
  //     display:flex;
  //     flex-direction:column;
  //     justify-content:flex-start;
  //     align-items:flex-start;
  //   ">

  //     <div style="font-size:13px; font-weight:600; margin-bottom:4px; width:100%; overflow:hidden; text-overflow:ellipsis;">
  //       ${data.teacher}
  //     </div>

  //     <div style="font-size:12px; color:#444; display:flex; align-items:center;">
  //       <span style="margin-right:6px;">🕒</span> ${data.time}
  //     </div>

  //     <div style="font-size:12px; color:#444; display:flex; align-items:center;">
  //       <span style="margin-right:6px;">🕒</span> ${data.endTime}
  //     </div>

  //     <div style="font-size:12px; color:#2E7D32; display:flex; align-items:center;">
  //       <span style="margin-right:6px;">⏱</span> ${data.duration}
  //     </div>

  //     <div style="position:absolute; right:6px; top:6px;">
  //       <img src="${environment.masterDomain}/employee/login/v2/api/profileImage?userId=${data.tempId}"
  //            style="width:20px; height:20px; border-radius:4px; object-fit:cover;" />
  //     </div>

  //   </div>
  // `;
  // }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.getteachPeriodList();
  }

  clickedData(params: any) {
    if (params.colDef.field === 'section' || !params.value || params.value.type === "NO_CLASS" || params.value.type === 'EXAM') {
      return;
    }

    const clickedData = {
      section: params.data.section,
      sectionStudentCount: params.data.sectionStudentCount,
      sectionName: params.data.sectionName,
      period: params.colDef.field,
      teacher: params.value.employeeName,
      duration: params.value.duration,
      time: params.value.startTime,
      endTime: params.value.endTime,
      imageList: params.value.imageList,
      payrollId: params.value.payrollId,
      subject: params.value.subject,
      topicName: params.value.topicName,
      subTopicName: params.value.subTopicName,
      periodName: params.value.periodName,
      studentCount: params.value.studentCount
    };
    // console.log("Clicked Period Data:", clickedData);
    this.imgDialog(clickedData);
  }

  imgDialog(params: any) {
    // console.log("dialog opened ", params)
    this.dialog.open(NewperiodImageDialogComponent, {
      width: '820px',
      height: '600px',
      maxWidth: '100%',
      autoFocus: false,
      disableClose: false,
      hasBackdrop: true,
      data: params
    })

  }


  setHeader(tab: any) {
    this.selectedDate = new Date();
    this.customDate = moment(this.selectedDate).format("DD-MM-YYYY");
    this.activeTab = "Today"
    if (tab == "overall") {
      this.currentTable = ""
      this.los = ""
      this.stateName = ""
      this.cityName = ""
      this.campusName = ""
      this.empName = ""
      this.section = true;
      this.overallList = false;
      this.overall = false;
      this.showDate = true;
      this.showFilter = true;
      this.getLosColumns();
      this.showLocation = true;
      this.rowData = this.losTableData;
    }
    else if (tab == "los") {
      this.currentTable = ""
      this.stateName = ""
      this.cityName = ""
      this.campusName = ""
      this.empName = ""
      this.section = true;
      this.overallList = false;
      this.overall = false;
      this.showFilter = true;
      this.getStateColumns();
      this.showLocation = true;
      this.showDate = true;
      this.rowData = this.stateTableData;
    }
    else if (tab == "state") {
      this.currentTable = ""
      this.cityName = ""
      this.campusName = ""
      this.empName = ""
      this.getCityColumns();
      this.section = true;
      this.overallList = false;
      this.overall = false;
      this.showLocation = true;
      this.showDate = true;
      this.showFilter = true;
      this.rowData = this.cityTableData;
    }
    else if (tab == "city") {
      this.currentTable = ""
      this.campusName = ""
      this.empName = ""
      this.section = true;
      this.overallList = false;
      this.overall = false;
      this.showLocation = true;
      this.showDate = true;
      this.showFilter = true;
      this.getcampusColumns();
      this.rowData = this.campusTableData;
    }
  }

  openfacultyTrackDialog() {
    this.dialog.open(FacultytrackingnewdialogComponent, {
      width: '540px',
      height: '1100px',
      panelClass: ['animate__animated', 'animate__slideInRight'],
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      disableClose: false,
      hasBackdrop: true,
      data: ""
    })
  }

  viewLocation() {
    window.open(`campusGooglemap?location=${this.campusId}`);
  }

  openFilterDialog() {
    const dialogRef = this.dialog.open(DialogFilterComponent, {
      width: '425px',
      height: '1100px',
      panelClass: ['animate__animated', 'animate__slideInRight'],
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      disableClose: false,
      hasBackdrop: true,
      data: this.customDate
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      // console.log("Dialog returned:", result);

      if (result) {
        this.campusId = result;
        this.getSectionTableData();
        console.log("Received campus ID:", this.campusId);
      }
    });

  }

  onStatusClick(item: any) {
    const status = item.statusName.toLowerCase();
    if (status === 'pending') {
      this.getPendingData();
    }
    else if (status === 'started') {
      this.getStateDate();
    }
    else if (status === 'completed') {
    }

    else if (status === 'total campus' || status === 'total') {
    }
  }

  getStateDate() {
    this.getStateColumn();
    this.httpservice.getStateDetails(this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.rowData = [];
          this.gridApi?.setGridOption('rowData', []);
          this.spinner.hide();
          return
        }
        // console.log('res', res);

        this.rowData = res ? res : [];
        this.spinner.hide();
      },
      error: (err: any) => {
        // console.log('err', err);
        this.spinner.hide();
      }
    })
  }

  getStateColumn() {
    this.colDefs = [
      {
        field: 'campusName', headerName: 'campus Name',
        cellStyle: { 'text-align': 'left' },
        headerStyle: { 'text-align': 'center', },
      },

      {
        field: 'principalName', headerName: 'Principal Name',
        cellStyle: { 'text-align': 'left' },
        headerStyle: { 'text-align': 'center', },
      },
      {
        field: 'designation', headerName: 'Designation',
        cellStyle: { 'text-align': 'left' },
        headerStyle: { 'text-align': 'center', },
      },
      {
        field: 'contactNo', headerName: 'Contact No',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
      },
    ]
  }

  getPendingData() {
    this.getPendingColumn();
    this.httpservice.getPendingDetails(this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return
        }
        // console.log('res', res);

        this.rowData = res ? res : [];
        this.PendingData = res ? res : [];
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  getPendingColumn() {
    this.colDefs = [
      {
        field: 'campusName', headerName: 'campus Name',
        cellStyle: { 'text-align': 'left' },
        headerStyle: { 'text-align': 'center', },
      },

      {
        field: 'principalName', headerName: 'Principal Name',
        cellStyle: { 'text-align': 'left' },
        headerStyle: { 'text-align': 'center', },
      },
      {
        field: 'designation', headerName: 'Designation',
        cellStyle: { 'text-align': 'left' },
        headerStyle: { 'text-align': 'center', },
      },
      {
        field: 'contactNo', headerName: 'Contact No',
        cellStyle: { 'text-align': 'right' },
        headerStyle: { 'text-align': 'center', },
      },
    ]
  }

}
